(() => {
  // The free-shipping threshold lives in Shopify's shipping settings as 70 USD and is converted
  // per market at checkout. Theme copy says "$70", so shoppers in other currencies get the converted
  // amount instead, rounded UP so the stated threshold is never lower than what checkout requires.
  const FREE_SHIP_USD = 70;
  const localizeFreeShipping = (root) => {
    const cur = window.Shopify && window.Shopify.currency;
    const rate = cur ? Number(cur.rate) : 0;
    if (!cur || !cur.active || cur.active === 'USD' || !(rate > 0)) return;
    const amount = Math.ceil(FREE_SHIP_USD * rate);
    let label;
    try { label = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active, maximumFractionDigits: 0 }).format(amount); }
    catch { label = `${amount} ${cur.active}`; }
    // "$70" only: not "$70.00" (a price) and not "$700". A trailing "." or "," that ends a sentence is fine.
    const token = new RegExp('\\$' + FREE_SHIP_USD + '(?!\\d|[.,]\\d)', 'g');
    const scope = root === document ? document.body : root;
    if (!scope) return;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        if (!node.nodeValue.includes('$' + FREE_SHIP_USD)) return NodeFilter.FILTER_REJECT;
        const tag = node.parentElement && node.parentElement.tagName;
        return tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEMPLATE' ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => { node.nodeValue = node.nodeValue.replace(token, label); });
  };
  const init = (root = document) => {
    localizeFreeShipping(root);
    root.querySelectorAll('[data-canvas-cart]:not([data-ready]),[data-canvas-search]:not([data-ready])').forEach(b=>{b.dataset.ready='1';b.addEventListener('click',()=>{const target=document.querySelector(b.hasAttribute('data-canvas-cart')?'#header-group [data-testid="cart-drawer-trigger"]':'#header-group button[aria-label="Search"]');if(target)target.click();});});
    const count=document.querySelector('[data-canvas-count]');const nativeCount=document.querySelector('#header-group cart-icon');
    if(count&&nativeCount&&!count.dataset.ready){count.dataset.ready='1';const sync=()=>{const text=nativeCount.querySelector('.cart-bubble__text-count')?.textContent||nativeCount.querySelector('[ref="cartBubbleCount"]')?.textContent;if(text&&count.textContent!==text.trim())count.textContent=text.trim();};new MutationObserver(sync).observe(nativeCount,{subtree:true,childList:true,characterData:true});sync();}

    root.querySelectorAll('video[data-hero-video]:not([data-lazy-ready])').forEach(video => {
      video.dataset.lazyReady = '1';
      video.addEventListener('playing', () => { video.dataset.playing = '1'; });
      const start = () => {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting && !document.hidden) video.play().catch(() => {});
          else video.pause();
        }));
        observer.observe(video);
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    });
    root.querySelectorAll('video.jf-rows__asset:not([data-lazy-ready]), video.jf-steps__asset:not([data-lazy-ready])').forEach(video => {
      video.dataset.lazyReady = '1';
      let nearby = false;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        if (nearby && !document.hidden && !motion.matches && !navigator.connection?.saveData) video.play().catch(() => {});
        else video.pause();
        if (motion.matches || navigator.connection?.saveData) video.controls = true;
      };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          nearby = entry.isIntersecting;
          if (nearby && video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
          update();
        });
      }, { rootMargin: '300px 0px' });
      observer.observe(video);
      document.addEventListener('visibilitychange', update);
      motion.addEventListener('change', update);
    });

    root.querySelectorAll('.jf-det__a:not([data-canvas])').forEach(a => {
      a.dataset.canvas = '1';
      const children = [...a.children];
      const specs = children.length > 0 && children.every(el => el.tagName === 'P' && el.firstElementChild?.tagName === 'STRONG' && el.textContent.trim() !== el.firstElementChild.textContent.trim());
      if (specs) {
        const grid = document.createElement('dl'); grid.className = 'jf-det__specs';
        children.forEach(p => { const label = p.firstElementChild; const dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = label.textContent; label.remove(); dd.textContent = p.textContent.trim();grid.append(dt,dd); });a.replaceChildren(grid);
      } else children.forEach(el => {
        if (el.tagName === 'P' && el.children.length === 1 && el.firstElementChild.tagName === 'STRONG' && el.textContent.trim() === el.firstElementChild.textContent.trim() && /^(UL|OL)$/.test(el.nextElementSibling?.tagName)) {
          const list = el.nextElementSibling, card = document.createElement('div');card.className='jf-det__card';a.insertBefore(card,el);card.append(el,list);
        }
      });
    });
    root.querySelectorAll('.jf-canvas-gallery:not([data-ready])').forEach(g => {
      g.dataset.ready='1';
      const slides=[...g.querySelectorAll('[data-slide]')], thumbs=[...g.querySelectorAll('[data-thumb]')];
      const strip=g.querySelector('.jf-canvas-gallery__thumbs');
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      // `index` is the slide actually shown; `wanted` is the slide last asked for. Arrows step from `wanted`: pick()
      // awaits an image decode before it commits `index`, so stepping from `index` dropped clicks made while loading.
      let index=0, request=0, wanted=0;
      // Slide a programmatic scroll is heading to. While set, settle() must not "correct" the
      // position: a smooth scroll that stalls >150ms short of halfway would otherwise snap back.
      let target=null, targetUntil=0;
      const prepare = async n => {
        const video=slides[n]?.querySelector('video');
        if(video?.dataset.poster&&!video.poster)video.poster=video.dataset.poster;
        const img=slides[n]?.querySelector(':scope > img');
        if(!img)return;
        if(img.dataset.srcset)img.srcset=img.dataset.srcset;
        if(img.dataset.src)img.src=img.dataset.src;
        try { await img.decode(); } catch {}
      };
      const sync = n => {
        index=n;wanted=n;
        thumbs.forEach((b,i)=>b.setAttribute('aria-current',String(i===n)));
        g.querySelector('[data-counter]').textContent=`${n+1} / ${slides.length}`;
        g.querySelector('[data-prev]').disabled=n===0;
        g.querySelector('[data-next]').disabled=n===slides.length-1;
        const visible=parseInt(getComputedStyle(strip).getPropertyValue('--thumb-visible'),10)||4;
        const first=Math.max(0,Math.min(thumbs.length-visible,n-Math.floor((visible-1)/2)));
        strip.scrollTo({left:thumbs[first].offsetLeft,behavior:reduced.matches?'instant':'smooth'});
        slides.forEach((el,i)=>{const v=el.querySelector('video');if(v){if(i===n)v.play().catch(()=>{});else v.pause();}});
        prepare(n);prepare(n+1);prepare(n-1);
      };
      const pick = async n => {
        n=Math.max(0,Math.min(slides.length-1,n));
        wanted=n;
        const ticket=++request;
        await prepare(n);
        if(ticket!==request||!g.isConnected)return;
        const scroller=g.querySelector('slideshow-slides');
        target=n;targetUntil=performance.now()+1200;
        scroller.scrollTo({left:n*scroller.clientWidth,behavior:Math.abs(n-index)===1&&!reduced.matches?'smooth':'instant'});
        sync(n);
      };
      thumbs.forEach((b,i)=>b.addEventListener('click',()=>pick(i)));
      g.querySelector('[data-prev]').addEventListener('click',()=>pick(wanted-1));
      g.querySelector('[data-next]').addEventListener('click',()=>pick(wanted+1));
      g.addEventListener('slideshow:select',e=>{if(e.target===g)sync(e.detail.index);});
      g.addEventListener('keydown',e=>{
        if(e.target.closest('video'))return;
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();pick(wanted+(e.key==='ArrowRight'?1:-1));}
        if(e.key==='Home'||e.key==='End'){e.preventDefault();pick(e.key==='Home'?0:slides.length-1);}
      });
      g.setVariant = async id => {
        const host=g.closest('.jf-gallery-source');
        if(!host)return;
        host.dataset.requestedVariant=id;
        if(g.dataset.variantId===id)return;
        const template=[...host.querySelectorAll('template[data-gallery-variant]')].find(t=>t.dataset.galleryVariant===id);
        if(!template)return;
        // importNode, not cloneNode: template.content is an inert document where images never load, so
        // decode() rejected instantly and the swap showed a black slide until the image downloaded.
        const replacement=document.importNode(template.content.querySelector('.jf-canvas-gallery'),true);
        const nextSlides=[...replacement.querySelectorAll('[data-slide]')];
        const nextThumbs=[...replacement.querySelectorAll('[data-thumb]')];
        const currentMedia=slides[index]?.dataset.mediaId;
        const nextIndex=Math.max(0,nextSlides.findIndex(slide=>slide.dataset.mediaId===currentMedia));
        const changed=nextSlides.map((slide,i)=>slide.dataset.mediaId!==slides[i]?.dataset.mediaId);
        const warmImage=async img=>{
          if(!img)return;
          if(img.dataset.srcset)img.srcset=img.dataset.srcset;
          if(img.dataset.src)img.src=img.dataset.src;
          img.loading='eager';
          try{await img.decode();}catch{}
        };
        await Promise.all(nextSlides.flatMap((slide,i)=>changed[i]||i===nextIndex
          ?[warmImage(slide.querySelector(':scope > img')),warmImage(nextThumbs[i]?.querySelector('img'))]:[]));
        if(!g.isConnected||host.dataset.requestedVariant!==id)return;
        ++request;
        if(nextSlides.length!==slides.length){
          g.querySelectorAll('video').forEach(v=>v.pause());
          g.replaceWith(replacement);
          init(host);
          return;
        }
        nextSlides.forEach((slide,i)=>{
          if(!changed[i])return;
          slides[i].querySelector('video')?.pause();
          slides[i].replaceChildren(...slide.childNodes);
          slides[i].dataset.mediaId=slide.dataset.mediaId;
          slides[i].setAttribute('slide-id',slide.getAttribute('slide-id'));
          thumbs[i].replaceChildren(...nextThumbs[i].childNodes);
          thumbs[i].setAttribute('aria-label',nextThumbs[i].getAttribute('aria-label'));
        });
        g.dataset.variantId=id;
        if(nextIndex!==index){
          const scroller=g.querySelector('slideshow-slides');
          scroller.scrollTo({left:nextIndex*scroller.clientWidth,behavior:'instant'});
        }
        sync(nextIndex);
      };
      const scroller=g.querySelector('slideshow-slides');
      let settleTimer;
      const settle=()=>{
        if(!scroller.clientWidth)return;
        const n=Math.max(0,Math.min(slides.length-1,Math.round(scroller.scrollLeft/scroller.clientWidth)));
        if(target!==null){
          if(n===target||performance.now()>targetUntil)target=null;
          else{clearTimeout(settleTimer);settleTimer=setTimeout(settle,150);return;}
        }
        if(n!==index){++request;g.select(n,undefined,{animate:false});sync(n);}
      };
      scroller.addEventListener('scroll',()=>{clearTimeout(settleTimer);settleTimer=setTimeout(settle,150);},{passive:true});
      scroller.addEventListener('scrollend',settle);
      // A swipe, drag or wheel means the shopper is driving: stop protecting the programmatic target.
      ['pointerdown','touchstart','wheel'].forEach(t=>scroller.addEventListener(t,()=>{target=null;},{passive:true}));
      let drag=null, suppress=false;
      strip.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='mouse'||e.button!==0)return;
        drag={x:e.clientX,left:strip.scrollLeft,id:e.pointerId};suppress=false;
      });
      strip.addEventListener('pointermove',e=>{
        if(!drag)return;
        const dx=e.clientX-drag.x;
        if(Math.abs(dx)>5){suppress=true;strip.style.scrollSnapType='none';strip.setPointerCapture(e.pointerId);strip.scrollLeft=drag.left-dx;}
      });
      const stop=()=>{drag=null;strip.style.scrollSnapType='';};
      strip.addEventListener('pointerup',stop);strip.addEventListener('pointercancel',stop);strip.addEventListener('lostpointercapture',stop);
      strip.addEventListener('pointerleave',()=>{if(!suppress)drag=null;});
      strip.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopPropagation();suppress=false;}},true);
      customElements.whenDefined('slideshow-component').then(()=>{
        if(!g.isConnected)return;
        const first=slides[0]?.querySelector('img');
        const warm=()=>{prepare(1);};
        if(!first||first.complete)warm();else first.addEventListener('load',warm,{once:true});
        thumbs[0].setAttribute('aria-current','true');g.querySelector('[data-prev]').disabled=true;
      });
      new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)slides.forEach(el=>el.querySelector('video')?.pause());},{threshold:0}).observe(g);
    });
    root.querySelectorAll('.product-details:not([data-canvas-ready])').forEach(details=>{
      details.dataset.canvasReady='1';const section=details.closest('.shopify-section');
      const purchase=details.querySelector('button[type="submit"].add-to-cart-button'), stickyBar=document.querySelector('.sticky-add-to-cart__bar');
      if(purchase&&stickyBar){const updateSticky=()=>{const live=details.querySelector('button[type="submit"].add-to-cart-button');const stuck=String(!!live&&live.getBoundingClientRect().bottom<0);if(stickyBar.dataset.canvasStuck!==stuck)stickyBar.dataset.canvasStuck=stuck;};let pending=false;window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;updateSticky();});}},{passive:true});window.addEventListener('resize',updateSticky);updateSticky();}

      const mirror=()=>{
        const price=details.querySelector('.jf-bundle__tier.is-selected [data-price]')?.textContent;
        const btn=details.querySelector('button[type="submit"].add-to-cart-button');if(!btn||!price)return;
        let label=btn.querySelector('.add-to-cart-text__content')||btn.querySelector('.add-to-cart-text')||btn.querySelector('.jf-canvas-atc-label');
        if(!label){label=document.createElement('span');label.className='jf-canvas-atc-label';[...btn.childNodes].filter(n=>n.nodeType===3&&n.textContent.trim()).forEach(n=>n.remove());btn.append(label);}
        if(label){const text=`Add to cart · ${price}`;if(!btn.disabled && label.textContent.trim()!==text)label.textContent=text;}
        details.querySelectorAll('.jf-atc-total').forEach(el=>el.remove());
        const sticky=document.querySelector('sticky-add-to-cart'), info=sticky?.querySelector('.sticky-add-to-cart__info');
        if(info){let total=info.querySelector('.jf-sticky-total');if(!total){total=document.createElement('div');total.className='jf-sticky-total';info.append(total);}if(total.textContent!==price)total.textContent=price;}

      };
      let queued=false;new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;mirror();});}).observe(details,{subtree:true,childList:true,characterData:true});mirror();
      section.addEventListener('shopify:product:select',async e=>{
        try{
          const result=await e.promise;const v=result?.detail?.resource;if(!v?.id)return;
          const id=String(v.id).split('/').pop();section.querySelectorAll('.jf-canvas-gallery').forEach(g=>g.setVariant?.(id));const head=details.querySelector('jf-product-head');head?.render?.(id);
          const bundle=details.querySelector('jf-bundle');if(bundle){bundle.current=id;bundle.update?.();}
          details.querySelector('jf-low-stock')?.render?.(id);
          const cards=details.querySelector('jf-variant-cards');if(cards){cards.querySelector('[data-current]').textContent=v.title;cards.querySelectorAll('[data-value]').forEach(b=>{const on=b.dataset.value===v.option1||b.dataset.value===v.title;b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',String(on));});}
          mirror();
        }catch{}
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
